'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homepageOnEnter = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _effects = require('redux-saga/effects');

var _friendbuy = require('redux/saga/selectors/friendbuy');

var _member = require('redux/saga/helpers/member');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var homepageOnEnter = /*#__PURE__*/exports.homepageOnEnter = _regenerator2.default.mark(function homepageOnEnter(client, nextState, replaceState) {
  var fbuyQueryParamVal;
  return _regenerator2.default.wrap(function homepageOnEnter$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          // If a user has a FriendBuy shortlink that redirects to a our homepage due to local caching,
          // we want to redirect them to the our dedicated referral page
          fbuyQueryParamVal = nextState.location.query[_friendbuy.FBUY_QUERY_PARAM];

          if (!fbuyQueryParamVal) {
            _context.next = 5;
            break;
          }

          _context.next = 4;
          return (0, _effects.call)(replaceState, '/referral?' + _friendbuy.FBUY_QUERY_PARAM + '=' + fbuyQueryParamVal);

        case 4:
          return _context.abrupt('return', _context.sent);

        case 5:
          _context.next = 7;
          return (0, _effects.call)(_member.memberHasStatus, client, 'CANCELLED');

        case 7:
          if (!_context.sent) {
            _context.next = 10;
            break;
          }

          _context.next = 10;
          return (0, _effects.call)(replaceState, '/rejoin');

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, homepageOnEnter, this);
});